import { theme } from "@/config/theme";

export const DESKTOP_HEADER_BREAKPOINT = theme.primitives.grid.scale[5];
export const SEARCH_HEADER_BREAKPOINT = theme.primitives.grid.scale[3];
export const DESKTOP_HEADER_MEDIA_QUERY = `@media (min-width: ${DESKTOP_HEADER_BREAKPOINT})`;
export const MOBILE_HEADER_MEDIA_QUERY = `@media not (min-width: ${DESKTOP_HEADER_BREAKPOINT})`;
export const MOBILE_SEARCH_MEDIA_QUERY = `@media not (min-width: ${SEARCH_HEADER_BREAKPOINT})`;

export const MAIN_MENU_DOM_ID = "main-menu";
export const PROFILE_MENU_DOM_ID = "profile-menu";
export const SEARCH_OFFCANVAS_DOM_ID = "search-offcanvas";
